export default "__VITE_ASSET__cp$3vJo41T1cpHN8Y1mXiQ__"